












































import { easing, styler, tween } from "popmotion";

import { Component, Vue } from "vue-property-decorator";
import { Console, Events } from "@/common/global.ts";

import Store from "@/store.ts";
import BasePage from "@/common/base-page.ts";

import UIFooterBasic from "@/views/ui/FooterBasic.vue";
import UIHeaderBasic from "@/views/ui/HeaderBasic.vue";
import UINavigation from "@/views/ui/Navigation.vue";
import UIPreloader from "@/views/ui/Preloader.vue";

@Component({
    components: {
        UIFooterBasic,
        UIHeaderBasic,
        UINavigation,
        UIPreloader,
    },
})
export default class Home extends BasePage {

    /**
     * [name description]
     *
     * @type {[type]}
     */
    public name: string = "page/home";

    /**
     * [loadedClass description]
     *
     * @type {[type]}
     */
    protected loadedClass: string = "state-unloaded";

    /**
     * [created description]
     *
     * @return {[type]} [description]
     */
    public created() {
        // this.bind("Handle_Mobile");
    }

    /**
     * [mounted description]
     *
     * @return {[type]} [description]
     */
    public mounted() {
        this.loadedClass = Store.state.hasLoaded ?
            "state-preload-complete" : "state-preload-incomplete";
    }


    // Animation
    // -----------------------------------------------------------------

    /**
     * [AnimateIn description]
     */
    public AnimateIn(): void {
        super.AnimateIn();
        this.setPageName();
    }

    /**
     * [AnimateOut description]
     *
     * @param {[type]} onComplete: any [description]
     */
    public AnimateOut(onComplete: any = null): void {
        super.AnimateOut();

        setTimeout(onComplete, 750);
    }

    /**
     *
     */
    public AnimateHeaders(): void {
        const header: HTMLElement = <HTMLElement> (<UIHeaderBasic> this.$refs.header).$el;
        const header2: HTMLElement = <HTMLElement> (<UIHeaderBasic> this.$refs.header2).$el;
        const offsetA: any = window.offset(header);
        const offsetB: any = window.offset(header2);
        const diff = offsetB.top - offsetA.top;

        // console.log( diff, offsetA, offsetB);

        header.style.transform = "translate(0, " + diff + "px)";
    }


    // Event Handlers
    // ----------------------------------------------------------------

    /**
     * All files have been loaded
     */
    private Handle_OnComplete(): void {
        this.loadedClass = "state-preload-complete";

        document.body.classList.add("state-preload-complete");

        this.AnimateHeaders();
    }

}
